/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getLocationsByCustomerId } from 'core/api/customer.api';
import { ICustomerLocation } from 'pages/Customers/Customers.models';

export interface IState {
    data: ICustomerLocation[];
    isLoading: boolean;
    error: object | null;
}

const initialState: IState = {
  data: [],
  error: null,
  isLoading: false,
};

export const getLocationsByCustomerIdAction = createAsyncThunk(
  'getLocationsByCustomerIdAction',
  async (customerId: string | number, { rejectWithValue }) => {
    try {
      const { data } = await getLocationsByCustomerId(customerId);
      return data;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const LocationsSlice = createSlice({
  name: 'getLocationsByCustomerId',
  initialState,
  reducers: {
    clear: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(getLocationsByCustomerIdAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLocationsByCustomerIdAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getLocationsByCustomerIdAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
        state.data = [];
      });
  },
});

export const { clear: clearLocationsByCustomerIdAction } = LocationsSlice.actions;

export const getLocationsByCustomerIdReducer = LocationsSlice.reducer;
